import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Separate axios instance for file uploads (no Content-Type default)
// Allows browser to set proper multipart/form-data with boundary parameter
const uploadClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 120000,  // 2 minutes for large files on slow networks
});

export const authAPI = {
  requestOTP: async (phone) => {
    const response = await api.post('/auth/request-otp', { phone });
    return response.data;
  },

  verifyOTP: async (phone, otp) => {
    const response = await api.post('/auth/verify-otp', { phone, otp });
    return response.data;
  },
};

export const uploadAPI = {
  uploadFile: async (token, documentId, file, onProgress) => {
    const formData = new FormData();
    formData.append('token', token);
    formData.append('document_id', documentId);
    formData.append('file', file);

    const response = await uploadClient.post('/api/upload', formData, {
      onUploadProgress: (progressEvent) => {
        if (onProgress) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(percentCompleted);
        }
      },
      // Browser automatically sets Content-Type with boundary
    });

    return response.data;
  },

  getRequestByToken: async (token) => {
    const response = await api.get(`/api/requests/by-token/${token}`);
    return response.data;
  },
};

export default api;